import NotificationLogList from "./NotificationLogList";

export default NotificationLogList;
